var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35678 18.7879H13.6386C13.1568 19.7584 12.1557 20.4286 10.9985 20.4286C9.8414 20.4286 8.84034 19.7584 8.35678 18.7879Z",
    fill: "#130F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8543 16.6958C18.8543 17.4543 18.2384 18.0702 17.48 18.0702H4.51715C3.75872 18.0702 3.14282 17.4543 3.14282 16.6958C3.14282 16.2937 3.31758 15.912 3.62299 15.6507C4.81747 14.6411 5.49954 13.1735 5.49954 11.6193V9.42887C5.49954 6.59538 7.65265 4.25562 10.4098 3.9604V2.16189C10.4098 1.83613 10.6728 1.57144 10.9986 1.57144C11.3243 1.57144 11.5873 1.83613 11.5873 2.16189V3.9604C14.3444 4.25562 16.4976 6.59538 16.4976 9.42887V11.6193C16.4976 13.1735 17.1796 14.6411 18.3656 15.6456C18.6795 15.912 18.8543 16.2937 18.8543 16.6958Z",
    fill: "#130F40"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.6ce335298ece9fdda3e386f0c16456ae.svg";
export { ForwardRef as ReactComponent };